export * from './StaticPageContent'
